module.exports = __webpack_public_path__ + "img/tarj1-4.c8585b17.svg";